import {FormikProps, useFormik} from 'formik'
import {initVoucherFilterValues, IVoucherFilterType} from './_model'
import {useRittApp} from '../../../utils/contextProvider/RittAppProvider'
import {KTIcon} from '../../../../_metronic/helpers'
import OptimizedSelectBox from '../../../utils/components/OptimizedSelectBox'
import FlatPickrDate from '../../../utils/components/FlatPickrDate'
import {ISelectOption} from '../../../utils/core/_model'
import useVoucherList from '../../../hooks/useVoucherList'

type Props = {
  onFilter: (values: Partial<IVoucherFilterType>) => void
}

const FilterVoucher = ({onFilter}: Props) => {
  const {voucherList} = useVoucherList()
  const {userInfo} = useRittApp()

  const voucherFilter = useFormik({
    initialValues: initVoucherFilterValues,
    onSubmit: async (values) => {
      const {username, voucher, ...sendValues} = values
      onFilter(sendValues)
    },
  })

  const onSelectUser = (id: number) => voucherFilter.setFieldValue('userId', id)

  const onSelectVoucher = (id: number) => voucherFilter.setFieldValue('voucherId', id)

  const resetForm = () => {
    voucherFilter.resetForm()
    onFilter({sdate: '', edate: '', userId: null, voucherId: null})
  }

  return (
    <>
      <button
        type='button'
        className='btn btn-light-primary me-3 border border-1 border-gray-500'
        id='dropdownFilterButton'
        data-bs-toggle='dropdown'
        aria-expanded='false'
        data-bs-auto-close='outside'
      >
        <KTIcon iconName='filter' className='fs-2' />
        Filter
      </button>
      <div
        className='dropdown-menu menu menu-sub menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-300px w-md-350px py-4'
        aria-labelledby='dropdownFilterButton'
      >
        <div className='px-7 py-5'>
          <div className='fs-5 text-gray-900 fw-bolder'>Filter Options</div>
        </div>

        <div className='separator border-gray-200'></div>

        <div className='px-7 py-5' data-kt-user-table-filter='form'>
          <form onSubmit={voucherFilter.handleSubmit}>
            <div className='mb-4'>
              <label className='form-label fs-6 fw-bold'>
                <span className=''>Username:</span>
              </label>

              <OptimizedSelectBox
                formik={voucherFilter}
                fieldValue='username'
                placeholder='Select user'
                setSelect={onSelectUser}
                options={userInfo}
              />
            </div>

            <div className='mb-4'>
              <label className='form-label fs-6 fw-bold'>
                <span className=''>Start Time:</span>
              </label>

              <div id='sdate' className=''>
                <FlatPickrDate
                  placeholder='Select start time'
                  fieldName='sdate'
                  formik={voucherFilter}
                  container='sdate'
                />
              </div>
            </div>

            <div className='mb-4'>
              <label className='form-label fs-6 fw-bold'>
                <span className=''>End Time:</span>
              </label>

              <div id='edate' className=''>
                <FlatPickrDate
                  placeholder='Select end time'
                  fieldName='edate'
                  formik={voucherFilter}
                  container='edate'
                />
              </div>
            </div>

            <div className='mb-4'>
              <label className='form-label fs-6 fw-bold'>
                <span className=''>Voucher:</span>
              </label>

              <OptimizedSelectBox
                formik={voucherFilter}
                fieldValue='voucher'
                placeholder='Select voucher'
                setSelect={onSelectVoucher}
                options={voucherList}
              />
            </div>

            <div className='d-flex justify-content-end mt-6'>
              <button
                type='button'
                className='btn btn-light btn-active-light-primary fw-bold me-2 px-6'
                data-kt-menu-dismiss='true'
                data-kt-user-table-filter='reset'
                onClick={() => resetForm()}
              >
                Reset
              </button>
              <button
                type='submit'
                className='btn btn-primary fw-bold px-6'
                data-kt-menu-dismiss='true'
                data-kt-user-table-filter='filter'
              >
                Apply
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default FilterVoucher
